import Head from "next/head";
import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getAdobeScriptGI, getAdobeScriptMMT } from "@mmt/event-logger";

interface LoadAdobeScriptProps {
  env?: "development" | "production";
  partner?: "mmt" | "gi";
  isLoadScript?: boolean;
}

const LoadAdobeScript: React.FC<LoadAdobeScriptProps> = ({
  env = "development",
  partner = "mmt",
  isLoadScript = false,
}) => {
  if (isLoadScript) {
    return (
      <Head>
        <script
          src={
            partner === "mmt" ? getAdobeScriptMMT(env) : getAdobeScriptGI(env)
          }
          async
        />
      </Head>
    );
  }
  return null;
};

export default LoadAdobeScript;
